import React, {useEffect, useContext} from 'react'
import {Button} from 'antd'
import DeleteComponent from "../common/DeleteComponent";
import EditComponent from "../common/EditComponent";
import {Arguments} from "../common/Arguments";
import {sideMenuContext} from "../../../router/IndexRouter";
import {GetApiMethod} from "../common/ApiMethod";
import TableComponent from "../common/TablePaginationComponent";


export default function PartyActivities(props) {
    const currentUrl = window.location.href;
    const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
    const getApi = Arguments.host + "/society_organization/base/branch/api!partyActivity.do";

    useEffect(() => {
        setDataSource([]);
        GetApiMethod({getApi, setDataSource, setCopyDataSource});
    }, [getApi])

    const columns = [
        {
            title: '序号',
            dataIndex: 'showIndex',
            width: 100,
            sorter: (a, b) => a.showIndex - b.showIndex,
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '活动主题',
            dataIndex: 'activityName',
            width: 180
        },
        {
            title: "主持人",
            dataIndex: 'activityCompere',
            width: 100
        },
        {
            title: "活动时间",
            dataIndex: 'activityDate',
            width: 120
        },
        {
            title: "活动形式",
            responsive: ['lg'],
            dataIndex: 'activityForm',
            width: 140
        },
        {
            title: "参加人数",
            responsive: ['lg'],
            dataIndex: 'activityScope',
            width: 100
        },
        {
            title: "活动地址",
            dataIndex: 'activityAddress',
            width: 220
        },
        {
            title: "申请经费",
            responsive: ['lg'],
            dataIndex: 'activityApplyMoney',
            width: 100
        },
        {
            title: "审批经费",
            dataIndex: 'activityApprovalMoney',
            width: 100
        },
        {
            title: "审核状态",
            dataIndex: 'checkStatus',
            width: 100
        },
        {
            title: "操作",
            width: 140,
            render: (item) => (
                <>
                    <EditComponent item={item} url={currentUrl}/>
                    <DeleteComponent
                        item={item}
                        postApi={[Arguments.host + "/society_organization/base/branch/api!addPartyActivity.do"]}
                        getApi={getApi}
                    />
                </>
            )
        }
    ];

    const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}))

    return (
        <>
            <Button type="primary" onClick={() => props.history.push("/base/party-activities/add")}
                    style={{marginBottom: 10}}>新增</Button>
            <TableComponent dataSource={indexDataSource} columns={columns}/>
        </>
    )
}